import React, { useState } from "react";
import "./AccountHolderHome.css";
import CustomButton from "components/widgets/custom-button/CustomButton.js";
import { titles } from "constants/titles";
import { useHistory } from "react-router-dom";
import { ROUTES_CONSTANTS } from "routes/route-constants";
import { useSelector } from "react-redux";
import { IconQuestion, IconSmallQuestion } from "assets/SVGs/SVGs";
import ConfirmationModal from "components/layout/confirmation-modal/ConfirmationModal";
import { logo_bam_std, sub_profile, curv } from "assets/images/images";

const AccountHolderHome = () => {
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const accountHolderData = useSelector(
    (store) => store?.userDetail?.accountHolderData
  );
  const userData = useSelector((store) => store?.auth?.userData);
  const guestUserData = useSelector((store) => store?.guestUser?.guestUserData);
  const { eSignHistory } = useSelector((store) => store?.userDetail);

  const history = useHistory();

  const isEsignHistoryAvailable = () => {
    if (
      eSignHistory?.account_holder_info_changes &&
      eSignHistory?.active_subscription_changes &&
      eSignHistory?.sale_orders
    ) {
      return (
        eSignHistory?.account_holder_info_changes?.length > 0 ||
        eSignHistory?.active_subscription_changes?.length > 0 ||
        eSignHistory?.sale_orders?.length > 0
      );
    }
    return false;
  };

  const onReviewAndSign = () => {
    history.push(ROUTES_CONSTANTS?.reviewAndSign);
  };

  return accountHolderData && Object.keys(accountHolderData)?.length > 0 ? (
    <div>
      <div className="ahh_welcome_container">
        {/* Header with Logo and Help Icon */}
        <div className="ahh_header_section">
          <div className="ahh_logo_container">
            <img
              src={logo_bam_std}
              alt="Bay Alarm Medical"
              className="ahh_logo_image"
            />
          </div>
          <div className="ahh_help_icon_container">
            <IconQuestion
              fillColor={"#fff"}
              className={"ahh_help_icon"}
              onClick={() => setShowConfirmationModal(true)}
            />
          </div>
        </div>

        {/* Profile Section */}
        <div className="ahh_profile_section">
          <div className="ahh_profile_image_container">
            <img
              src={sub_profile}
              alt="Profile"
              className="ahh_profile_image"
            />
          </div>

          <div className="ahh_welcome_text">
            <h1 className="ahh_welcome_title">{titles?.welcome}</h1>
            <h2 className="ahh_user_name">
              {userData?.isGuestUser
                ? guestUserData?.guest_user_name
                : accountHolderData?.firstname +
                " " +
                accountHolderData?.lastname}
            </h2>
            <p className="ahh_user_email">{accountHolderData?.email}</p>
          </div>
        </div>

        {/* Action Buttons */}
        {!userData?.isGuestUser ? (
          <div className="ahh_action_buttons">
            <CustomButton
              text={titles?.edit_account_details}
              width={"100%"}
              isWhiteButton={true}
              onClick={() => history.push(ROUTES_CONSTANTS?.accountHolder)}
            />
            <CustomButton
              text={titles?.change_password}
              width={"100%"}
              isWhiteButton={true}
              onClick={() =>
                history.push(ROUTES_CONSTANTS?.changePassword)
              }
            />
            {isEsignHistoryAvailable() ? (
              <CustomButton
                text={titles?.review_and_sign}
                isWhiteButton={true}
                width={"100%"}
                onClick={() => onReviewAndSign()}
              />
            ) : null}
          </div>
        ) : null}
      </div>
      {/* Curved Bottom */}
      <div>
        <img src={curv} alt="Curved bottom" className="ahh_curved_image" />
      </div>
      <ConfirmationModal
        show={showConfirmationModal}
        svgIcon={
          <IconQuestion fillColor="#DB4E3B" width="32" height="32" />
        }
        title={
          <p>
            {titles.help_tips_text_1 + " "}
            <IconSmallQuestion className={"ahh_tip_icon"} width="18" height="18" />
            {" " + titles.help_tips_text_2}
          </p>
        }
        btnText={titles?.got_it}
        setShow={() => setShowConfirmationModal(false)}
        onClick={() => setShowConfirmationModal(false)}
      />
    </div>
  ) : (
    <></>
  );
  // return accountHolderData && Object.keys(accountHolderData)?.length > 0 ? (
  //   <div className="account_holder_home_container mb10">
  //     <p className="body_p">
  //       {userData?.isGuestUser ? titles?.welcome_guest : titles?.welcome}
  //     </p>
  //     <p className="ahh_name display_h2 mb10">
  //       {userData?.isGuestUser
  //         ? guestUserData?.guest_user_name
  //         : accountHolderData?.firstname + " " + accountHolderData?.lastname}
  //     </p>
  //     <p className="body_h2">{accountHolderData?.email}</p>
  //     <p className="body_h2">
  //       {"Phone1: " +
  //         (accountHolderData?.phone_one
  //           ? formatPhoneNumber(accountHolderData?.phone_one)
  //           : "NA")}
  //     </p>
  //     {accountHolderData?.phone_two ? (
  //       <p className="body_h2 mb10">
  //         {"Phone2: " +
  //           (accountHolderData?.phone_two
  //             ? formatPhoneNumber(accountHolderData?.phone_two)
  //             : "NA")}
  //       </p>
  //     ) : null}

  //     <p className="body_h2">{titles?.mailing_address}</p>
  //     <p className="body_h2">
  //       {accountHolderData && accountHolderData?.street
  //         ? accountHolderData?.street + `\n`
  //         : ""}
  //       {accountHolderData && accountHolderData?.apt_no
  //         ? accountHolderData?.apt_no
  //         : ""}
  //     </p>
  //     <p className="body_h2 mb10">
  //       {accountHolderData?.city +
  //         ", " +
  //         accountHolderData?.region_code +
  //         " " +
  //         accountHolderData?.post_code}
  //     </p>
  //     <CustomButton
  //       text={titles?.edit_details}
  //       width={"250px"}
  //       className={"mb10"}
  //       onClick={() => history.push(ROUTES_CONSTANTS?.accountHolder)}
  //     />
  //     {!userData?.isGuestUser && isEsignHistoryAvailable() ? (
  //       <CustomButton
  //         text={titles?.review_and_sign}
  //         width={"250px"}
  //         className={"caregiver_card_btn mb10"}
  //         onClick={() => {
  //           onReviewAndSign();
  //         }}
  //       />
  //     ) : null}
  //   </div>
  // ) : (
  //   <></>
  // );
};

export default AccountHolderHome;
